import cx from 'classnames'
import { Fragment, useContext } from 'react'

import { type SanityAccountDetailsStrings } from '@data/sanity/queries/types/blocks'
import { LanguageContext } from '@lib/language-context'
import { getPageUrl } from '@lib/routes'
import { UserContext } from '@lib/user/context'
import ButtonLink from '@components/buttons/button-link'

interface AccountDetailsProps {
  accountDetailsStrings: SanityAccountDetailsStrings
  className?: string
}

const AccountDetails = ({
  accountDetailsStrings,
  className,
}: AccountDetailsProps) => {
  const { locale } = useContext(LanguageContext)
  const { user } = useContext(UserContext)

  const accountAddressPageUrl = getPageUrl({
    pageType: 'accountAddressPage',
    locale,
  })

  const addressCount = user?.addresses?.length ?? 0
  const defaultAddress =
    user?.addresses?.find((address) => address.isDefault) ??
    user?.addresses?.[0]

  return (
    <div
      className={cx(className, 'bg-box-bg border border-box-border p-6 lg:p-8')}
    >
      <h4>{accountDetailsStrings.accountAccountDetailsHeading}</h4>

      {defaultAddress && (
        <div className="mt-5 text-sm leading-normal">
          {defaultAddress.formatted.map((addressLine, index) => (
            <Fragment key={index}>
              {addressLine}
              {defaultAddress.formatted[index + 1] && <br />}
            </Fragment>
          ))}
        </div>
      )}

      <ButtonLink
        href={accountAddressPageUrl}
        className="w-full mt-5 text-sm font-medium"
        // icon="ArrowRight" // TODO: Missing icon. Not found in design.
        // iconSize={ButtonIconSize.NORMAL}
        // iconAlignment={ButtonIconAlignment.LEFT}
      >
        {accountDetailsStrings.accountViewAddresses} ({addressCount})
      </ButtonLink>
    </div>
  )
}

export default AccountDetails
